/* eslint-disable react/jsx-props-no-spreading */

import './Table.scss';

import classNames from 'classnames';

import TableHeader from './TableHeader';
import TableList from './TableList';
import PaginationButtons from './TableList/PaginationButtons';

function Table(props) {
  const emptyTable = !props.items?.length && !props.isLoading;
  return (
    <div className="flex-column align-center h-100">
      <div
        className={classNames(
          'table table-container mb-20 w-100',
          emptyTable && 'table--empty'
        )}
      >
        <TableHeader columns={props.columns} />
        <TableList
          emptyTable={emptyTable}
          onClick={props.onClickRow}
          {...props}
        />
      </div>
      {props.pagination?.totalPages > 1 && (
        <PaginationButtons
          pagination={props.pagination}
          onChangePange={props.onChangePange}
        />
      )}
    </div>
  );
}

export default Table;
